"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.darwinia = void 0;
const defineChain_js_1 = require("../../utils/chain/defineChain.js");
exports.darwinia = (0, defineChain_js_1.defineChain)({
    id: 46,
    name: 'Darwinia Network',
    nativeCurrency: {
        decimals: 18,
        name: 'RING',
        symbol: 'RING',
    },
    rpcUrls: {
        default: {
            http: ['https://rpc.darwinia.network'],
            webSocket: ['wss://rpc.darwinia.network'],
        },
    },
    blockExplorers: {
        default: { name: 'Explorer', url: 'https://explorer.darwinia.network' },
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 69420,
        },
    },
});
//# sourceMappingURL=darwinia.js.map